export enum WorkflowStatus {
  NewBill = 'New Bill',
  ActiveReview = 'Active Review',
  Monitoring = 'Monitoring',
  Irrelevant = 'Irrelevant',
  Closed = 'Closed',
}

// "New Bill" is assigned only by new-bill detection, so it is never offered to users.
export const USER_SELECTABLE_WORKFLOW_STATUSES = Object.values(WorkflowStatus).filter(
  (status) => status !== WorkflowStatus.NewBill,
);
